module.exports = __webpack_public_path__ + "static/media/ws-click-and-collect.6cad58e4.svg";